import * as Utils from "../utils";
import { paramProperties } from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/List",
    // Carries the whole param union again, so a list's item is described by
    // exactly the same shape as a param. That includes a list of lists.
    type: "object",
    properties: {
      ...Utils.properties,
      ...paramProperties,
    },
    required: ["type"],
  },
];
